<template>
  <div class="dialog">
    <div class="mask" @touchmove.prevent></div>
    <div class="dialog-content">
      <p class="title">{{ modal.title }}</p>
      <div class="wrapper">
        <img src="../assets/shareTips.jpg" alt="" style="width: 4.3rem;height: 3.2rem;margin-top: .06rem;">
        <div class="text">{{ modal.text }}</div>
        <div class="btn-group">
          <div  class="btn2" @click="submit"><p>{{ modal.confirmButtonText }}</p></div>
          <div  class="btn" @click="cancel"><p>{{ modal.cancelButtonText }}</p></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'shareTips',
    props: {
      dialogOption: Object
    },
    data() {
      return {
        resolve: '',
        reject: '',
        promise: '', // 保存promise对象
      }
    },
    computed: {
      modal: function() {
        let options = this.dialogOption;
        return {
          title: options.title || '',
          text: options.text,
          cancelButtonText: options.cancelButtonText ? options.cancelButtonText : '确定',
          // confirmButtonText: options.confirmButtonText ? options.confirmButtonText : '取消',
        }
      }
    },
    methods: {
      //确定,将promise断定为完成态
      submit() {
        this.resolve('submit');
      },
      // 取消,将promise断定为reject状态
      cancel() {
        this.reject('cancel');
      },
      //显示confirm弹出,并创建promise对象，给父组件调用
      confirm() {
        this.promise = new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
        return this.promise; //返回promise对象,给父级组件调用
      }
    }

  }
</script>

<style scoped>
  .dialog {
    position: relative;
  }
  .dialog-content {
    position: fixed;
    box-sizing: border-box;
    padding: .20rem;
    width: 4.56rem;
    height: 4.56rem;
    min-height: 1.40rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: .05rem;
    background: #fff;
    z-index: 99999999999;
    box-shadow: 0 .16rem .71rem -.16rem rgba(0,0,0,.8);
    border: 1px #191919 dashed;
  }
  .title {
    font-size: .4rem;
    font-weight: 600;
    line-height: 1.5;
  }

  .text {
    font-size: .35rem;
    font-weight: bold;
    line-height: 1.5;
    text-align: center;
    color: rgba(229,229,229,1);
    margin-top: .27rem;
  }

  .btn-group {
    margin-top: .4rem;
    display: flex;
    position: absolute;
    justify-content: center;
    right: 0;
    bottom: .10rem;
    width: 100%;
  }
  .btn {
    width: 2.44rem;
    height: .56rem;
    border-radius: .1rem;
    background: #191919;
    display: flex;
    justify-content: center;
    align-items: center;
    /*padding: .1rem .2rem;*/
    font-size: .3rem;
    margin-bottom: .3rem;
    color: white;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 50001;
    background: rgba(0, 0, 0, .5);
  }
  .wrapper{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/shareTips.vue